export const sanitizeBrandingImageUrl = brandingImageUrl => {
  // This is a client-side stop-gap to stop requesting whatever urls are passed in a query param
  //   until we can use an appropriately strict image-src CSP directive, and as such doesn't
  //   warrant the extensive plumbing to get the server-configured 'brandingImageHost'
  //   value through to the client
  const allowedBaseUrls = [
    // Staging brandingImageHost
    'https://d1p58lcjr73i9.cloudfront.net/',
    // Prod brandingImageHost
    'https://ds8491psuu2uu.cloudfront.net/',
  ];

  return allowedBaseUrls.find(base => brandingImageUrl?.startsWith(base))
    ? brandingImageUrl
    : '';
};
